function TrimJson<T>(obj: Record<any, any | null> | undefined, undefinedNulls: boolean = false) {
    let result: Record<any, any | null> = {}
    if (obj) {

        Object.entries(obj).forEach(([key, val]) => {
            if (undefinedNulls && val === null)
                result[key] = undefined;

            if (val !== undefined && val !== null) {
                result[key] = (typeof val === 'string') ? val.trim() : val;
            }
        })
    }

    return result as T
}

export default TrimJson